import { Dispatch } from "redux";
import { match } from "src/base/Either";
import { handleError } from "src/helpers/errorHandler";
import { FetchAdminNotice } from "../../domain/usecases/fetchAdminNotice";
import { FetchSystemNotice } from "../../domain/usecases/fetchSystemNotice";
import { adminNoticeFetchData, adminNoticeStateChanged, systemNoticeFetchData, systemNoticeStateChanged } from "../store/adminNotice";

export class AdminNoticeContainer {
    fetchAdminNotice: FetchAdminNotice
    fetchSystemNotice: FetchSystemNotice

    constructor(fetchAdminNotice: FetchAdminNotice, fetchSystemNotice: FetchSystemNotice) {
        this.fetchAdminNotice = fetchAdminNotice;
        this.fetchSystemNotice = fetchSystemNotice;
    }

    async getNotices(dispatch: Dispatch, page: number) {
        dispatch(adminNoticeStateChanged(true))

        let either = await this.fetchAdminNotice.repository.fetchNotices(page)
        match(either, (failure) => {
            handleError(failure.message)
        }, (data) => {
            dispatch(adminNoticeFetchData(data))
        })

        dispatch(adminNoticeStateChanged(false))
    }

    async getSystemNotices(dispatch: Dispatch, page: number) {
        dispatch(systemNoticeStateChanged(true))

        let either = await this.fetchSystemNotice.repository.fetchSystemNotices(page)
        match(either, (failure) => {
            handleError(failure.message)
        }, (data) => {
            dispatch(systemNoticeFetchData(data))
        })

        dispatch(systemNoticeStateChanged(false))
    }
}